import React from 'react'

function Stars() {
  return (
    <div className='stars-container'>
        <div className="stars"></div>
        <div className="stars2"></div>
        <div className="stars3"></div>
    </div>
  )
}

export default Stars